<template>
  <div>
    <template v-if="loading">
      <content-placeholders>
        <content-placeholders-text :lines="10" />
      </content-placeholders>
    </template>
    <template v-else-if="items.length">
      <div class="catalog-view__item" style="margin-bottom: 40px">
        <div class="catalog-view__subtitle catalog-view__subtitle-item" id="netto">Логистические данные Нетто</div>
        <div class="catalog-view__table-simple">
          <table>
            <tr v-for="(item, key) in items" :key="key">
              <th>{{ item.name }}</th>
              <td>{{ item.value }}</td>
            </tr>
          </table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import {EVENT_ADD_CHIPS} from "../../views/ProductCard";

export default {
  name: 'packing-netto',
  components: {
  },
  props: {
    product_id: {
      require: true
    }
  },
  data: () => ({
    items: [],
    loading: true
  }),
  created() {
    this.$api.product.packingNetto(this.product_id).then((response) => {
      if (response && response.data) {
        this.items = response.data
        if (this.items.length) {
          this.$emit(EVENT_ADD_CHIPS, {
            link: 'netto',
            title: 'Логистические данные НЕТТО',
            size: null,
            order: 9
          })
        }
      }
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {

  }
}
</script>